import { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import DispatchProduct from '../components/dispatch/DispatchProduct';
import ProductList from '../components/product/ProductList';
import ProductCountList from '../components/product/ProductCountList';
import CompnyDetails from '../components/CompanyDetails';
import AddChallanDetails from '../components/AddChallanDetails';
import { demoPagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';
import AddInvoiceDetails from '../components/AddInvoiceDetails';
import InvoiceList from '../components/InvoiceList';
import SubInvoiceList from '../components/subInvoiceList';
import DispatchList from '../components/product/DispatchList';
import AvrDispatchList from '../components/product/AvrDispatchList';
import AssignProducts from '../components/product/AssignProducts';
import ProductAssignReport from '../components/reports/ProductAssignReport';
import DispatchProductReport from '../components/reports/DispatchProductReport';
import UnscannedProductReport from '../components/reports/UnscannedProductReport';
import MasterProduct from '../components/product/MasterProduct';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage'))
};

const screenMenus: RouteProps[] = [
	/**
	 * Getting Started
	*/

	// General Pages
	{
		path: "dispatchProduct",
		element: <DispatchProduct />
	},
	{
		path: "productList",
		element: <ProductList />
	},
	{
		path: "product/stocklist",
		element: <ProductCountList />
	},
	{
		path: "dispatchList",
		element: <DispatchList />
	},
	{
		path: "avrDispatchList",
		element: <AvrDispatchList />
	},
	{
		path: "companyDetails",
		element: <CompnyDetails />
	},
	{
		path: "challanDetails",
		element: <AddChallanDetails />
	},
	{
		path: "invoiceList",
		element: <InvoiceList />
	},
	{
		path: "subInvoiceList",
		element: <SubInvoiceList />
	},
	{
		path: "assignProducts",
		element: <AssignProducts />
	},
	{
		path: "masterProduct",
		element: <MasterProduct />
	},
	{
		path: "reports/assignedStock",
		element: <ProductAssignReport />
	},
	{
		path: "reports/dispatchedStock",
		element: <DispatchProductReport />
	},
	{
		path: "reports/unscannedStock",
		element: <UnscannedProductReport />
	},
];

const presentation: RouteProps[] = [
	{
		path: "/",
		element: <ProductList />
	},
	{
		path: "addInvoice/:deliveryChallanId",
		element: <AddInvoiceDetails />
	},
	{
		path: '/dashboard',
		element: <LANDING.DASHBOARD />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
	},
]

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};

const contents = [...screenMenus, ...presentation];

export default contents;
